import React, { useEffect, useState } from "react";
import "./Service.scss";
import top_banner_service from "../../assets/service/SVG/top_banner_service.webp";
import CardService from "../../components/cardservice/CardService";

import Element_top_service from "../../components/topelementservice/Element_top_service";
import axios from "axios";
import SlideNew from "../../components/slidernew/SlideNew";
import LoanService from "../loanservice/LoanService";
import Pagination from "@mui/material/Pagination";
import usePaginations from "../../Paginations";
import Contant from "../../Contant";

import ComponentFinance from "../moreabout/finance/Finance";
import ComponentPlaneTicket from "../moreabout/planticket/PlanTicket";
import ComponentTicket from "../moreabout/ticket/Ticket";
import ComponentMore from "../moreabout/more/More";

export default function Service(props) {
  const [finance, setFinance] = useState(false);
  const [air, setAir] = useState(false);
  const [ticket, setTicket] = useState(false);
  const [more, setMore] = useState(false);

  const [all, setAll] = useState(true);

  const allOnClick = () => {
    setAll(true);
    setFinance(false);
    setAir(false);
    setMore(false);
    setTicket(false);
  };

  const financeOnClick = () => {
    setFinance(true);
    setAir(false);
    setMore(false);
    setTicket(false);
    setAll(false);
  };

  const airOnClick = () => {
    setAir(true);
    setFinance(false);
    setMore(false);
    setTicket(false);
    setAll(false);
  };

  const ticketOnClick = () => {
    setTicket(true);

    setFinance(false);
    setMore(false);
    setAir(false);
    setAll(false);
  };

  const moreOnClick = () => {
    setMore(true);

    setFinance(false);
    setTicket(false);
    setAir(false);
    setAll(false);
  };

  const [datas, setDatas] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios({
        method: "get",
        url: Contant + "api/posts?type=products",
        Headers: {
          Accept: "application.json",
          "Content-Type": "application/json",
        },
      });

      const datakey = response.data.products;

      setDatas(() => {
        let allNews = [];
        for (let j in datakey) {
          allNews = allNews.concat(datakey[j]);
        }
        return allNews;
      });
    };
    fetchData();
  }, [props]);

  let [page, setPage] = useState(1);
  const PER_PAGE = 9;

  const count = Math.ceil(datas.length / PER_PAGE);
  var _DATA = usePaginations(datas, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <div className="main_service">
      
      <Element_top_service
        question={"Bạn cần tiền"}
        request={"Dịch vụ tài chính tốt nhất trong tầm tay ban"}
        introduce={"Dịch vụ của chúng tôi"}
        last_introduce={
          "Tien Dung Finance cung cấp đa dạng các loại hình dịch vụ"
        }
        image={top_banner_service}
        className={"frame_img_banner_service"}
      />

      <div className="main_frame_serv">
        <div>
          <button
            className={all === true ? "active_themeMenu" : "nonactive"}
            onClick={() => allOnClick()}
          >
            Tất cả
          </button>
          <button
            className={finance === true ? "active_themeMenu" : "nonactive"}
            onClick={() => financeOnClick()}
          >
            Tài chính
          </button>
          <button
            className={air === true ? "active_themeMenu" : "nonactive"}
            onClick={() => airOnClick()}
          >
            Vé máy bay
          </button>
          <button
            className={ticket === true ? "active_themeMenu" : "nonactive"}
            onClick={() => ticketOnClick()}
          >
            Vé xe
          </button>
          <button
            className={more === true ? "active_themeMenu" : "nonactive"}
            onClick={() => moreOnClick()}
          >
            Khác
          </button>
        </div>

        <div>
          {all === true ? (
            <>
              {" "}
              <div className="style_frame_main_card">
                <div className="frame_service_item">
                  {_DATA.currentDatas().map((item, index) => (
                    <div key={index}>
                      <CardService
                        Title={item.title}
                        image={Contant + "api/data/images/" + item.coverPhoto}
                        date={item.date}
                        id={item.id}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="frame_piantion">
                <Pagination
                  count={count}
                  size="small"
                  page={page}
                  variant="outlined"
                  shape="rounded"
                  onChange={handleChange}
                  className="style_panigation"
                />
              </div>
            </>
          ) : (
            ""
          )}
          {finance === true ? <ComponentFinance /> : ""}
          {air === true ? <ComponentPlaneTicket /> : ""}
          {ticket === true ? <ComponentTicket /> : ""}
          {more === true ? <ComponentMore /> : ""}
        </div>
      </div>

      <div className="background_slide_new">
        <h2>Tin mới nhất</h2>

        <SlideNew />
      </div>

      <LoanService />
    </div>
  );
}
